import { useRecoilValue } from "recoil";
import { phrasesAPIErrorAtom } from "./phrasesAPIErrorAtom";

export function useIsPhrasesAPIErrorValue() {
    return useRecoilValue(phrasesAPIErrorAtom);
}
